import { styled } from '@clickcease/cc-client-components-lib'

export const UserManagementStyled = styled('div', {
  width: 'calc(100% - 60px)',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  marginTop: '$10',
})

export const UserManagementTop = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
})

export const UserManagementTitle = styled('div', {
  fontWeight: '$rb',
  fontSize: '$h5',
  color: '$mainTextColor',
  marginRight: '12px',
})

export const UserManagementSearch = styled('div', {
  width: '260px',
})

export const TopLeft = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
})

export const TopRight = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '4px',
})
